// External links and URLs
export const EXTERNAL_LINKS = {
  PRICING_URL: 'https://trellus.ai/pricing',
  SUPPORT_CALENDLY_URL: 'https://calendly.com/dom-odo/30min',
  PARALLEL_UPGRADE_URL: 'https://buy.stripe.com/5kA00h0lY5qb3V67vT',
} as const

// Access control messages (can be customized per deployment)
export const ACCESS_CONTROL_MESSAGES = {
  ADMIN_ACCESS: {
    TITLE: 'Admin Access Required',
    MESSAGE: 'You need a paid team plan to access this section. Please contact support at support@trellus.ai to upgrade to a team plan.',
  },
  ADMIN_ACCESS_PAID: {
    TITLE: 'Admin Access Required',
    MESSAGE: 'You need administrator privileges to access this section. Contact your team administrator or schedule a call with our support team to get admin access.',
  },
  PAID_ACCESS: {
    TITLE: 'Unlock Premium Features',
    MESSAGE: 'This feature is available with our paid plans. Upgrade your subscription to access advanced features and boost your team\'s productivity.',
    BUTTON_TEXT: 'View Pricing & Upgrade'
  },
  PARALLEL_ACCESS: {
    TITLE: 'Unlock Parallel Dialing',
    MESSAGE: 'Enable multiple concurrent calls and advanced dialing features with our premium plans. Boost your team\'s calling efficiency today.',
    BUTTON_TEXT: 'View Pricing & Upgrade'
  }
} as const 